import type { ReportHistory } from '#shared/types';
import { type KeyedRequest, useKeyedRequest } from '#client/hooks/useKeyedRequest';
import { api } from '#client/lib/api';

import { ENDPOINT } from '#client/lib/endpoints';

/**
 * The last `limit` visits of the test behind `reportId`, looking back from it.
 * Pass `undefined` to skip.
 *
 * `limit` goes as a query parameter rather than being spliced into the path;
 * the key carries both, so changing either re-fetches.
 */
export function useReportHistory(
  reportId: number | undefined,
  limit: number,
): KeyedRequest<ReportHistory> {
  const path = reportId === undefined ? undefined : ENDPOINT.reportHistory(reportId);

  return useKeyedRequest<ReportHistory>(
    path === undefined ? undefined : JSON.stringify({ path, limit }),
    (signal) => api.get<ReportHistory>(path ?? '', { limit }, signal),
    'Could not load this record',
  );
}
